import React from 'react';
const loader = () => (
    <div className='Loader'>Loading...</div>
);
export default loader;


// WEBPACK FOOTER //
// ./src/components/Loader.js